import React from "react";
import "../styles/Home.css";
import UsePageTitle from "../components/UsePageTitle";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

const PrivacyPolicy = () => {
  UsePageTitle("Privacy Policy | Bravix Group");

  return (
    <>
      <section className="privacy_policy_content_section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="privacy_policy_wrapper">
                <div className="privacy_policy_header">
                  <h2>PRIVACY POLICY</h2>
                  <p className="last_updated">Last Updated: November 9, 2025</p>
                </div>

                <p className="privacy_intro">
                  This Privacy Policy describes Bravix Group's policies and
                  procedures regarding the collection, use, and disclosure of
                  your information when you use our services. It also explains
                  your privacy rights and how applicable laws protect you.
                </p>

                <p className="privacy_intro">
                  By using our website or services, you agree to the collection
                  and use of information in accordance with this Privacy Policy.
                </p>

                <div className="privacy_section">
                  <h3>1. Introduction</h3>
                  <p>
                    Bravix Group is committed to safeguarding the privacy of our
                    users. We assure you that your personal information is safe
                    with us - we do not sell, rent, or share your personal
                    information with third parties for marketing or promotional
                    purposes.
                  </p>
                  <p>
                    This policy explains how we collect, use, and protect the
                    information you provide to us through our website or related
                    services.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>2. Information We Collect</h3>
                  <p>
                    We do not collect any personal information from users
                    through our website. We do not use contact forms,
                    newsletters, or account registrations. Your visit to our
                    website is completely anonymous, and no personal or
                    identifiable data is stored or tracked.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>3. How We Use Your Information</h3>
                  <p>
                    Since Bravix Group does not collect any personal data, we do
                    not use, process, or share user information in any form.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>4. Data Storage</h3>
                  <p>
                    No personal data is collected or stored by Bravix Group. Our
                    website is hosted securely and follows standard web security
                    protocols to prevent unauthorized access.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>5. Disclosure of Your Information</h3>
                  <p>
                    Bravix Group does not disclose or share any client data with
                    third parties for marketing, promotional, or other purposes.
                    Since no personal data is collected, there is nothing to
                    disclose or share.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>6. International Data Transfers</h3>
                  <p>
                    Although we do not collect data, our website may be hosted
                    on servers located in different regions, including the
                    United States. Regardless of server location, we ensure that
                    your browsing data remains secure and anonymous.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>7. Data Retention</h3>
                  <p>
                    Since Bravix Group does not collect or store personal data,
                    there is no data retention policy required. Any server logs
                    are managed by our hosting provider and are not linked to
                    identifiable users.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>8. Cookies and Tracking Technologies</h3>
                  <p>
                    Our website does not use cookies, analytics tools, or any
                    tracking technologies. You can browse freely without any
                    data being collected or stored on your device.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>9. Your Rights</h3>
                  <p>
                    As Bravix Group does not collect or process any personal
                    information, there is no data for users to access, correct,
                    or delete.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>10. Services We Provide</h3>
                  <p>
                    Bravix Group specializes in recruitment services for the
                    construction industry, including the following sectors:
                  </p>
                  <ul>
                    <li>Multifamily Construction</li>
                    <li>Commercial Office Space</li>
                    <li>Hospitality</li>
                    <li>Warehouses & Manufacturing</li>
                    <li>Healthcare</li>
                    <li>K-12 Education</li>
                    <li>Higher Education</li>
                    <li>Municipal</li>
                    <li>Public Facilities</li>
                    <li>Energy & Industrial</li>
                    <li>Retail</li>
                    <li>Life Sciences & Tech</li>
                  </ul>
                  <p>
                    We connect top construction talent with developers and
                    contractors across these sectors, supporting projects such
                    as apartment builds, hospitals, schools, offices,
                    warehouses, and more.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>11. Third-Party Tools</h3>
                  <p>
                    We do not use any third-party tools such as Google
                    Analytics, chat widgets, or contact forms.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>12. Payment Processing</h3>
                  <p>
                    Bravix Group does not store or process any payment
                    information on our website.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>13. Communication Preferences</h3>
                  <p>
                    We do not send promotional messages, newsletters, or
                    marketing emails to users.
                  </p>
                </div>

                <div className="privacy_section">
                  <h3>14. Changes to This Policy</h3>
                  <p>
                    Bravix Group may update this Privacy Policy periodically.
                    Any updates will be posted on this page with an updated
                    "Last Updated" date. Continued use of our website after
                    changes implies acceptance of the new policy.
                  </p>
                </div>

                <div className="privacy_section privacy_contact">
                  <h3>15. Contact Us</h3>
                  <p>
                    If you have any questions about this Privacy Policy or our
                    data practices, please contact us:
                  </p>
                  <div className="contact_info">
                    <p>
                      <strong>Bravix Group</strong>
                    </p>
                    <p>
                      Email:{" "}
                      <a href="mailto:info@bravixgroup.com">
                        info@bravixgroup.com
                      </a>
                    </p>
                    <p>
                      Phone: <a href="tel:+18602953364">+1 860 295 3364</a>
                    </p>
                    <p>Address: lutz florida</p>
                    <p>
                      Website:{" "}
                      <a
                        href="https://bravixgroup.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://bravixgroup.com/
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
